import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	private readonly exludedUrl = ['/assets/i18n', 'openid-connect/token'];
	constructor(private loaderService: LoaderService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!this.exludedUrl.find((url) => req.url.includes(url))) {
			this.loaderService.show();
		}
		return next.handle(req).pipe(
			finalize(() => {
				if (!this.exludedUrl.find((url) => req.url.includes(url))) {
					this.loaderService.hide();
				}
			})
		);
	}
}
